<template>
  <file-selector
    v-model="file"
    background="transparent"
    border-radius="0"
    :accept="['.pdf']"
  >
    <template #label>
      <v-row no-gutters align="center" class="label pa-3 text-body-2">
        <v-icon left>picture_as_pdf</v-icon>
        <span class="mr-1">Drag and drop PDF or</span>
        <a>browse files</a>
      </v-row>
    </template>
  </file-selector>
</template>

<script>
import FileSelector from '@/components/Common/FileSelector';

export default {
  name: 'DenseFullTextPdfDropzone',
  components: { FileSelector },
  props: {
    value: {
      type: File,
      default: null,
    },
  },
  computed: {
    file: {
      get: function () {
        return this.value;
      },
      set: function (file) {
        this.$emit('input', file);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  color: #a7afbf;
}
</style>
